import { render, staticRenderFns } from "./RegistrationDisclaimer.vue?vue&type=template&id=6db930ba&scoped=true&"
import script from "./RegistrationDisclaimer.vue?vue&type=script&lang=js&"
export * from "./RegistrationDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDisclaimer.vue?vue&type=style&index=0&id=6db930ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db930ba",
  null
  
)

export default component.exports